export default __webpack_public_path__ + "static/media/open-box.c7ddc76d.svg";